import React from 'react';
import {Link} from 'react-router-dom';
import kidbrooke from '../images/kidbrooke.jpg';
import royalArsenal from '../images/royal-arsenal.jpg';
import plumsteadWestThamesmead from '../images/plumsteadWestThamesmead.jpg';
import poplar from '../images/poplar.jpg';
import alexandraGate from '../images/alexandraGate.jpg';
import {LanguageContext} from '../LanguageContext';
import translation from '../translations.json';

const Site = () => (
  <LanguageContext.Consumer>
    {({lang, changeLanguage}) => {
      return (
        <div className="flex flex-col text-center">
          <div className="bg-blue py-4">
            <h4 className="text-white text-2xl">{translation.site[lang.selected].SITE}</h4>
          </div>

          <Link to="/submission/kidbrooke">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={kidbrooke} alt="" />
          </Link>
          <Link to="/submission/royalArsenal">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={royalArsenal} alt="" />
          </Link>
          <Link to="/submission/plumsteadWestThamesmead">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={plumsteadWestThamesmead} alt="" />
          </Link>
          <Link to="/submission/alexandraGate">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={alexandraGate} alt="" />
          </Link>
          <Link to="/submission/poplar">
            <img className="w-2/3 p-4 m-4 border-2 border-blue rounded" src={poplar} alt="" />
          </Link>
        </div>
      );
    }}
  </LanguageContext.Consumer>
);

export default Site;



// WEBPACK FOOTER //
// ./src/components/Site.js